import { getContext } from '@/context';

const DRIVE_MINIAPP_ID = 'com.picsart.social.drive-chooser';

type DrivePickerFile = {
  sourceUrl?: string;
  thumbnailUrl?: string;
  content?: {
    resourceType?: string;
  };
  resourceType?: string;
  name?: string;
};

type DrivePickerOptions = {
  multiselect?: boolean;
  filters?: 'PHOTO' | 'VIDEO' | 'PHOTO,VIDEO';
};

type DrivePickerResult = {
  files: DrivePickerFile[];
};

type DrivePickerResponse = {
  result?: {
    files?: DrivePickerFile[];
    result?: {
      files?: DrivePickerFile[];
    };
  };
};

const openDrivePicker = async (
  options: DrivePickerOptions = {}
): Promise<DrivePickerResult | null> => {
  try {
    const ctx = getContext();
    const { multiselect = false, filters = 'PHOTO' } = options;

    await ctx.general.sharedStorage.dispatch({
      driveChooser: { multiselect, filters },
    });

    const resp = (await ctx.handlers.redirectToPackageId(DRIVE_MINIAPP_ID, {
      comeback: true,
    })) as DrivePickerResponse;

    // Read by shape, not by platform. Hosts that relay the chooser's close
    // payload through their own resolve (the picsart.com iframe, and gen.ai's
    // federated embed — where `isWeb()` is false) nest it one level deeper
    // than native does. Keyed on `isWeb()`, the embed read the native path,
    // found nothing, and a picked file was silently dropped.
    const files = resp?.result?.result?.files ?? resp?.result?.files;

    if (Array.isArray(files) && files.length > 0) {
      return { files };
    }

    return { files: [] };
  } catch {
    return null;
  }
};

export type { DrivePickerFile, DrivePickerOptions, DrivePickerResult };

export default openDrivePicker;
